import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RailCar } from '../../models/railcar.model';

@Component({
  selector: 'app-new-builds-learn-more',
  templateUrl: './new-builds-learn-more.component.html',
  styleUrls: ['./new-builds-learn-more.component.css'],
})
export class NewBuildsLearnMoreComponent {
  @Output('closeNewModelFn') closeNewModelFn: EventEmitter<void> =
    new EventEmitter();
  @Output('selectedCar') selectedCar: EventEmitter<RailCar> =
    new EventEmitter();

  @Input() showBegin = true;

  @Input() carDetails: RailCar = {
    model_id: 0,
    model_desc: '',
    gross_rail_load: '',
    capacity: 0,
    capacity_uom: '',
    gate_type: null,
    gate_size: null,
    hatch_cover: '',
    compartments: null,
    stencil_spec: null,
    insulation: null,
    coils: null,
    pressure: 0,
    country: '',
    state: '',
    count: 0,
    rate: 0,
    rate2: 0,
    file_name: '',
    age: 0,
    compliance_due: '',
    car_overview: '',
  };

  hopperDetails = {
    capacity: '3,250',
    gateType: 'Gravity',
    compartmentQty: '2',
    hatchCover: 'Circular',
    gravityGateSize: '13 x 42',
    grossRailLoad: '286,000',
  };

  closeModel(): void {
    this.closeNewModelFn.emit();
  }

  beginQuoteRequest(carDetails: RailCar): void {
    this.selectedCar.emit(carDetails);
  }
}
